<template>
  <div>
    Unknown menu item type
  </div>
</template>